import KeywordListPanel from './KeywordListPanel.vue';

export default KeywordListPanel;
